<template lang="pug">
span
  v-input.d-none(
    :value="value"
    :rules="rules")
  slot(:error="error")
</template>

<script>
import { reactive, toRefs, computed } from '@vue/composition-api'

export default {
  props: {
    value: String,
    rules: Array
  },

  setup (props, { emit }) {
    const state = reactive({
      error: computed(
        () =>
          props.rules
            .map(rule => rule(props.value))
            .filter(value => value !== true)
            .find(error => error)
      )
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>